import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgLoadingDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgLoading = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path fill="currentColor" d="M12 2a10 10 0 1 0 10 10h-2a8 8 0 1 1-8-8z" />
  </svg>
));
